import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { createStyles, withStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';

const styles = ({ palette }) =>
  createStyles({
    container: {
      width: 484,
      textAlign: 'center',
      fontWeight: 'bold',
      fontSize: '0.8em',
      padding: 10,
      textDecoration: 'none',
      position: 'fixed',
      textShadow: '0 3px 10px rgba(0, 0, 0, 0.5)',
      boxShadow: '0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23)',
      zIndex: '1201',
      bottom: 70,
      left: -219,
      transform: 'rotate(47deg) translateY(100%)',
      color: '#ffffff',
      transition: 'all ease-in-out 0.3s',
      '&:hover': {
        opacity: '0',
      },
    },
    environmentTitle: {
      marginLeft: 80,
      color: palette.background.paper,
      userSelect: 'none',
    },
  });

const EnvironmentRibbon = ({ classes, environmentConfUrl }) => {
  const [environment, setEnvironment] = useState({
    name: '',
    color: '',
  });

  useEffect(() => {
    if (environmentConfUrl.includes('dev')) {
      setEnvironment({
        name: 'DEV',
        color: '#007200',
      });
    } else if (environmentConfUrl.includes('qa')) {
      setEnvironment({
        name: 'QA',
        color: '#aa0000',
      });
    } else if (environmentConfUrl.includes('sta')) {
      setEnvironment({
        name: 'STAGING',
        color: '#121621',
      });
    } else if (environmentConfUrl.includes('demo')) {
      setEnvironment({
        name: 'DEMO',
        color: '#6d6d6d',
      });
    } else if (environmentConfUrl.match(/java-(eu|us)/i) || environmentConfUrl.match(/aima-(eu|us)/i)) {
      setEnvironment({
        name: 'PROD',
        color: '#ff0000',
      });
    } else {
      setEnvironment({
        name: '',
        color: '',
      });
    }
  }, [environmentConfUrl]);

  return (
    <>
      {environment.name && environment.color && (
        <div className={`${classes.container}`} style={{ backgroundColor: environment.color }}>
          <Typography className={classes.environmentTitle}>{environment.name}</Typography>
        </div>
      )}
    </>
  );
};

EnvironmentRibbon.propTypes = {
  classes: PropTypes.shape({
    container: PropTypes.string.isRequired,
    environmentTitle: PropTypes.string.isRequired,
  }).isRequired,
  environmentConfUrl: PropTypes.string.isRequired,
};

export default withStyles(styles, 'EnvironmentRibbon')(EnvironmentRibbon);
